/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Nothing_New_TitleInputs */

const en_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Other Items Available`)
};

const ar_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد منتجات أخرى لعرضها حاليًا`)
};

const de_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine weiteren Artikel verfügbar`)
};

const es_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay más artículos disponibles`)
};

const fr_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun autre article disponible`)
};

const it_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun altro articolo disponibile`)
};

const ja_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これ以上更新できる商品はありません`)
};

const ko_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로고침할 상품이 더 이상 없어요`)
};

const pt_br_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há outros itens disponíveis`)
};

const ru_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Других товаров пока нет`)
};

const th_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีสินค้าอื่นให้รีเฟรชแล้ว`)
};

const tr_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başka ürün bulunmuyor`)
};

const zh_cn_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无更多商品可刷新`)
};

const zh_tw_dialog_nothing_new_title = /** @type {(inputs: Dialog_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫無更多商品可刷新`)
};

/**
* | output |
* | --- |
* | "No Other Items Available" |
*
* @param {Dialog_Nothing_New_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_nothing_new_title = /** @type {((inputs?: Dialog_Nothing_New_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Nothing_New_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_nothing_new_title(inputs)
	if (locale === "ar") return ar_dialog_nothing_new_title(inputs)
	if (locale === "de") return de_dialog_nothing_new_title(inputs)
	if (locale === "es") return es_dialog_nothing_new_title(inputs)
	if (locale === "fr") return fr_dialog_nothing_new_title(inputs)
	if (locale === "it") return it_dialog_nothing_new_title(inputs)
	if (locale === "ja") return ja_dialog_nothing_new_title(inputs)
	if (locale === "ko") return ko_dialog_nothing_new_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_nothing_new_title(inputs)
	if (locale === "ru") return ru_dialog_nothing_new_title(inputs)
	if (locale === "th") return th_dialog_nothing_new_title(inputs)
	if (locale === "tr") return tr_dialog_nothing_new_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_nothing_new_title(inputs)
	return zh_tw_dialog_nothing_new_title(inputs)
});